module.exports = __webpack_public_path__ + "static/media/double_arrow_left.3db692d7.svg";